import React, { useState } from "react";
import { PageHeader } from "shared/components/Headers/PageHeader";
import { PlusCircleIcon } from "shared/icons/PlusCircleIcon";
import { useQueryClient } from "react-query";
import { cacheKeys, routes } from "config";
import { LoadingButton } from "@mui/lab";
import { surveysClient } from "../client/surveysClient";
import { SurveyTable } from "./SurveyTable";
import { SurveyLayouts } from "modules/MainSurveyEditor/helpers/blockForm";
import { useNavigate } from "react-router-dom";

const Surveys = () => {
  const [isCreatingSurvey, setIsCreatingSurvey] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const handleAddSurvey = async () => {
    try {
      setIsCreatingSurvey(true);
      const id = await surveysClient.createSurvey({
        title: "New survey",
        displayType: SurveyLayouts.Simple,
      });
      queryClient.invalidateQueries(cacheKeys.surveys.getSurveys);
      setIsCreatingSurvey(false);
      navigate(routes.survey(id));
    } catch (e) {
      console.error(e);
      setIsCreatingSurvey(false);
    }
  };

  return (
    <div className="layout-title-body-page layout-surveys">
      <PageHeader
        pageName="surveys"
        title="Surveys"
        actions={
          <LoadingButton onClick={handleAddSurvey} variant="contained" loading={isCreatingSurvey}>
            <PlusCircleIcon />
            Create survey
          </LoadingButton>
        }
      />

      <SurveyTable />
    </div>
  );
};

export default Surveys;
